import React from 'react'

import _modules from '../../_modules'

const AttendanceRecordsDetail = React.lazy(() =>
  import('./views/attendanceRecords/AttendanceRecordsDetail'),
)
const AttendanceRecords = React.lazy(() => import('./views/attendanceRecords/AttendanceRecords'))

const ExpensesDetail = React.lazy(() => import('./views/expenses/ExpensesDetail'))
const Expenses = React.lazy(() => import('./views/expenses/Expenses'))

const ExpenseTypesDetail = React.lazy(() => import('./views/expenseTypes/ExpenseTypesDetail'))
const ExpenseTypes = React.lazy(() => import('./views/expenseTypes/ExpenseTypes'))

const SalaryDetail = React.lazy(() => import('./views/salary/SalaryDetail'))
const Salary = React.lazy(() => import('./views/salary/Salary'))

const SalarysReportsDetail = React.lazy(() => import('./views/salaryReports/SalaryReportsDetail'))
const SalaryReports = React.lazy(() => import('./views/salaryReports/SalaryReports'))
const MonthlySalaryReports = React.lazy(() => import('./views/salaryReports/MonthlySalaryReports'))
const AnnualSalaryReports = React.lazy(() => import('./views/salaryReports/AnnualSalaryReports'))

const MPFsReportsDetail = React.lazy(() => import('./views/mpfReports/MPFReportsDetail'))
const MPFReports = React.lazy(() => import('./views/mpfReports/MPFReports'))
const MonthlyMPFReports = React.lazy(() => import('./views/mpfReports/MonthlyMPFReports'))
const AnnualMPFReports = React.lazy(() => import('./views/mpfReports/AnnualMPFReports'))

const BenefitsDetail = React.lazy(() => import('./views/benefits/BenefitsDetail'))
const Benefits = React.lazy(() => import('./views/benefits/Benefits'))

const ApplicationsDetail = React.lazy(() => import('./views/applications/ApplicationsDetail'))
const ApplicationsStaticDetail = React.lazy(() =>
  import('./views/applications/ApplicationsStaticDetail'),
)
const Applications = React.lazy(() => import('./views/applications/Applications'))

const WarningLettersDetail = React.lazy(() => import('./views/warningLetters/WarningLettersDetail'))
const WarningLetters = React.lazy(() => import('./views/warningLetters/WarningLetters'))

const CommendatoryLettersDetail = React.lazy(() =>
  import('./views/commendatoryLetters/CommendatoryLettersDetail'),
)
const CommendatoryLetters = React.lazy(() =>
  import('./views/commendatoryLetters/CommendatoryLetters'),
)

const PromotionLettersDetail = React.lazy(() =>
  import('./views/promotionLetters/PromotionLettersDetail'),
)
const PromotionLetters = React.lazy(() => import('./views/promotionLetters/PromotionLetters'))

const ReferenceLettersDetail = React.lazy(() =>
  import('./views/referenceLetters/ReferenceLettersDetail'),
)
const ReferenceLetters = React.lazy(() => import('./views/referenceLetters/ReferenceLetters'))

const staffEvaluationsDetail = React.lazy(() =>
  import('./views/staffEvaluations/staffEvaluationsDetail'),
)
const staffEvaluations = React.lazy(() => import('./views/staffEvaluations/staffEvaluations'))
const shifts = React.lazy(() => import('./views/shifts/Shifts'))

const _routes = []

if (_modules.attendance_records)
  _routes.push(
    ...[
      {
        path: '/attendance-records/:id',
        name: 'Attendance Record Detail',
        component: AttendanceRecordsDetail,
      },
      { path: '/attendance-records', name: 'Attendance Records', component: AttendanceRecords },
    ],
  )
if (_modules.expenses) {
  _routes.push(
    ...[
      {
        path: '/expenses/:id',
        name: 'Expense Detail',
        component: ExpensesDetail,
      },
      { path: '/expenses', name: 'Expenses', component: Expenses },
    ],
  )
  _routes.push(
    ...[
      {
        path: '/expense-types/:id',
        name: 'Expense Type Detail',
        component: ExpenseTypesDetail,
      },
      { path: '/expense-types', name: 'Expense Types', component: ExpenseTypes },
    ],
  )
}
if (_modules.salary)
  _routes.push(
    ...[
      {
        path: '/salary/:id',
        name: 'Salary Detail',
        component: SalaryDetail,
      },
      { path: '/salary', name: 'Salary', component: Salary },
    ],
  )
if (_modules.salary_reports)
  _routes.push(
    ...[
      {
        path: '/salary-reports/:id',
        name: 'Salary Report Detail',
        component: SalarysReportsDetail,
      },
      { path: '/salary-reports', name: 'Salary Report', component: SalaryReports },
      {
        path: '/monthly-salary-reports',
        name: 'Monthly Salary Report',
        component: MonthlySalaryReports,
      },
      {
        path: '/annual-salary-reports',
        name: 'Annual Salary Report',
        component: AnnualSalaryReports,
      },
    ],
  )
if (_modules.mpf_reports)
  _routes.push(
    ...[
      {
        path: '/mpf-reports/:id',
        name: 'MPF Report Detail',
        component: MPFsReportsDetail,
      },
      { path: '/mpf-reports', name: 'MPF Report', component: MPFReports },
      {
        path: '/monthly-mpf-reports',
        name: 'Monthly MPF Report',
        component: MonthlyMPFReports,
      },
      {
        path: '/annual-mpf-reports',
        name: 'Annual MPF Report',
        component: AnnualMPFReports,
      },
    ],
  )
if (_modules.benefits)
  _routes.push(
    ...[
      {
        path: '/benefits/:id',
        name: 'Benefit Detail',
        component: BenefitsDetail,
      },
      { path: '/benefits', name: 'Benefits', component: Benefits },
    ],
  )
if (_modules.applications)
  _routes.push(
    ...[
      {
        path: '/applications/:id',
        name: 'Application Detail',
        component: ApplicationsDetail,
      },
      {
        path: '/application-interfaces/:id',
        name: 'Application Interface',
        component: ApplicationsStaticDetail,
      },
      { path: '/applications', name: 'Applications', component: Applications },
    ],
  )
if (_modules.warning_letters)
  _routes.push(
    ...[
      {
        path: '/warning-letters/:id',
        name: 'Warning Letter Detail',
        component: WarningLettersDetail,
      },
      { path: '/warning-letters', name: 'Warning Letters', component: WarningLetters },
    ],
  )
if (_modules.commendatory_letters)
  _routes.push(
    ...[
      {
        path: '/commendatory-letters/:id',
        name: 'Commendatory Letter Detail',
        component: CommendatoryLettersDetail,
      },
      {
        path: '/commendatory-letters',
        name: 'Commendatory Letters',
        component: CommendatoryLetters,
      },
    ],
  )
if (_modules.promotion_letters)
  _routes.push(
    ...[
      {
        path: '/promotion-letters/:id',
        name: 'Promotion Letter Detail',
        component: PromotionLettersDetail,
      },
      {
        path: '/promotion-letters',
        name: 'Promotion Letters',
        component: PromotionLetters,
      },
    ],
  )
if (_modules.reference_letters)
  _routes.push(
    ...[
      {
        path: '/reference-letters/:id',
        name: 'Reference Letter Detail',
        component: ReferenceLettersDetail,
      },
      {
        path: '/reference-letters',
        name: 'Reference Letters',
        component: ReferenceLetters,
      },
    ],
  )

if (_modules.staff_evaluations)
  _routes.push(
    ...[
      {
        path: '/staff-evaluations/:id',
        name: 'Saff Evaluations Detail',
        component: staffEvaluationsDetail,
      },
      { path: '/staff-evaluations', name: 'Staff Evaluations', component: staffEvaluations },
    ],
  )

if (_modules.shifts) _routes.push(...[{ path: '/shifts', name: 'Shifts', component: shifts }])

export default _routes
